import React, { Fragment, useState } from 'react'
import { Filters, defaultFilters } from './Filters'
import { ClusterTable } from './ClusterTable'
import CloudCoreChart from './CloudCoreChart'

const CloudCoreCapacityReport = ({ clusters, customers, locations, trends, showFilters = true, reportSize = 'regular' }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const defaultPageSize = { small: 5, regular: 20, large: 100 }[reportSize]
  return (
    <Fragment>
      {showFilters && <Filters {...{ clusters, filters, customers, locations, changeFilters }} />}

      <ClusterTable {...{ clusters, filters, changeFilters, defaultPageSize }} />

      <CloudCoreChart {...{ clusters, filters, trends }} />
    </Fragment>
  )
}

export default CloudCoreCapacityReport
